module.exports = __webpack_public_path__ + "static/media/address_image.c329a317.svg";